module.exports = __webpack_public_path__ + "img/IMG-20200119-WA0006.cc88cb74.jpg";